import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { buildProgressStylesheet } from "./ElementProgressStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementProgress = (props) => {
  let element = props.element;
  const classes = style.classes(element);
  const stylesheet = buildProgressStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );
  const progressInner = useRef(null);

  if (props.builder == true) {
    useEffect(() => {
      if (element.options["progress-type"] == "dynamic") {
        const elementDiv = document.querySelector(
          `#builder .cf-element[data-element-id="${element.id}"]`
        );
        const stepDiv = elementDiv.closest(".cf-step");

        let stepPosition = parseInt(stepDiv.getAttribute("data-step-position"));

        const previousExcludedSteps = Array.from(
          document.querySelectorAll(
            "#builder .cf-step[data-progress-bar-count='false']"
          )
        ).filter(
          (stepDiv) => stepDiv.getAttribute("data-step-position") < stepPosition
        ).length;

        stepPosition = stepPosition - previousExcludedSteps;

        const stepCount = document.querySelectorAll(
          "#builder .cf-step[data-progress-bar-count='true']"
        ).length;

        const innerProgressWidth = (100 * stepPosition) / stepCount;
        progressInner.current.style.width = `${
          innerProgressWidth > 100 ? 100 : innerProgressWidth
        }%`;
        const progressMessageStepProgress = elementDiv.querySelector(
          ".cf-progress-step-progress"
        );
        if (progressMessageStepProgress) {
          $(progressMessageStepProgress).text(
            `${
              stepPosition > stepCount ? stepCount : stepPosition
            }/${stepCount}`
          );
        }
      } else if (element.options["progress-type"] == "static") {
        progressInner.current.style.width = null;
      }

      if (element.options["progress-type"] == "cart") {
        const elementDiv = document.querySelector(
          `#builder .cf-element[data-element-id="${element.id}"]`
        );
        const progressMessageDiv = elementDiv.querySelector(
          ".cf-progress-message"
        );

        if (progressMessageDiv) {
          let progressMessage = element.options["progress-message-cart"] || "";
          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = progressMessage;
          let progressText = tempDiv.textContent || tempDiv.innerText || "";
          let offerType =
            element.options["progress-cart-offer-type"] || "value";

          if (offerType === "quantity") {
            let quantityThreshold =
              props.variant.options["cart-quantity-threshold"] ||
              props.website.data["cart-quantity-threshold"] ||
              5;
            let newProgressMessage = progressText
              .replace("({cart.count})", "0")
              .replace("({cart.count_threshold_gap})", `${quantityThreshold}`)
              .replace("({cart.count_threshold})", `${quantityThreshold}`)
              .replace("({cart.value})", "$0.00")
              .replace("({cart.value_threshold_gap})", "$0.00")
              .replace("({cart.value_threshold})", "$0.00");
            $(progressMessageDiv).text(newProgressMessage);
          } else {
            let threshold =
              props.variant.options["cart-value-threshold"] ||
              props.website.data["cart-value-threshold"] ||
              50;
            let newProgressMessage = progressText
              .replace("({cart.value})", "$0.00")
              .replace("({cart.value_threshold_gap})", `$${threshold}.00`)
              .replace("({cart.value_threshold})", `$${threshold}.00`);
            $(progressMessageDiv).text(newProgressMessage);
          }
          progressInner.current.style.width = null;
        }
      }
    }, [
      element.options["progress-type"],
      element.options["progress-format"],
      element.options["progress-cart-offer-type"],
      props.variant.options["cart-value-threshold"],
      props.variant.options["cart-quantity-threshold"],
      element.lastUpdated,
    ]);
  }

  return (
    <React.Fragment>
      <div className="cf-progress">
        {element.options["progress-format"] == "line" && (
          <ElementProgressMessage element={element} />
        )}
        <div className={classes}>
          <div
            ref={progressInner}
            className="cf-progress-inner"
            data-progress-format={element.options["progress-format"]}
          >
            {element.options["progress-format"] == "box" && (
              <ElementProgressMessage element={element} />
            )}
          </div>
        </div>
      </div>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:progress`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

const ElementProgressMessage = (props) => {
  const element = props.element;
  return (
    <React.Fragment>
      {element.options["progress-type"] == "static" && (
        <div
          className="cf-progress-message cf-merge-tag-allowed"
          data-progress-format={element.options["progress-format"]}
          dangerouslySetInnerHTML={{
            __html: element.html,
          }}
          data-font={element.options["progress-text-font"]}
        ></div>
      )}

      {element.options["progress-type"] == "dynamic" && (
        <div
          className="cf-progress-message"
          data-font={element.options["progress-text-font"]}
        >
          {_.isNil(element.options["progress-step-translation"]) == false
            ? element.options["progress-step-translation"]
            : "Step"}{" "}
          <span className="cf-progress-step-progress"></span>
        </div>
      )}

      {element.options["progress-type"] == "cart" && (
        <div
          className="cf-progress-message cf-merge-tag-allowed"
          dangerouslySetInnerHTML={{
            __html: element.options["progress-message-cart"],
          }}
          data-font={element.options["progress-text-font"]}
        ></div>
      )}
    </React.Fragment>
  );
};

const style = {
  classes: (element) => {
    let options = element.options;
    let classes = "cf-row cf-progress-outer";

    let alignmentClass = "cf-outer-center";
    if (options["cf-alignment"]) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        alignmentClass = "cf-outer-left";
      } else if (options["cf-alignment"].indexOf("center") > -1) {
        alignmentClass = "cf-outer-center";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        alignmentClass = "cf-outer-right";
      }
    }
    classes += " " + alignmentClass;

    classes +=
      " " +
      (options["progress-format"] !== "box"
        ? "cf-progress-format-line"
        : "cf-progress-format-box");

    return classes;
  },
};

export default ElementProgress;
